<div>
<div class="filter-container" style="border-color: {{ color }};">
  <div class="active-filter-background" style="background-color: {{color}}"></div>
  <div class="filter-card" style="background-color: {{color}}" fxLayout="row">
    <span>
      <ng-container *ngIf="value !== null;else loadingValue">
        <img src="{{ 'assets/svg/' + filterIcon }}" />
      </ng-container>
    </span>
    <span
      ><span>
          {{ value | number }}
      </span>
      &nbsp;
      <span>{{ filterName }}</span></span
    >

  </div>
<!-- <hr style="border-color: {{ color }}" /> -->
</div>
<ng-template #loadingValue>
  <mat-spinner diameter="20" color="accent"></mat-spinner>
</ng-template>
